module.exports = __webpack_public_path__ + "img/ARK-alt.872bf73c.svg";